import {
  faChartLine,
  faTriangleExclamation,
  faStore,
  faMoneyBillWave,
  faClock,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';

// The six analytics pages, in one place: the sidebar and the home page both
// render from this, so adding or renaming a page cannot leave one of them behind.
//
// Visible to hasAnalyticsPrivilages (GlobalAdmin, Admin or Analytics). The API
// enforces the same set on api/analytics -- see RequireRolesAttribute.
const analyticsNav = [
  { to: '/analytics/margin', icon: faChartLine, label: 'analytics_margin_nav', description: 'analytics_margin_desc' },
  { to: '/analytics/shrinkage', icon: faTriangleExclamation, label: 'analytics_shrinkage_nav', description: 'analytics_shrinkage_desc' },
  { to: '/analytics/stores', icon: faStore, label: 'analytics_stores_nav', description: 'analytics_stores_desc' },
  { to: '/analytics/tender', icon: faMoneyBillWave, label: 'analytics_tender_nav', description: 'analytics_tender_desc' },
  { to: '/analytics/traffic', icon: faClock, label: 'analytics_traffic_nav', description: 'analytics_traffic_desc' },
  { to: '/analytics/quality', icon: faListCheck, label: 'analytics_quality_nav', description: 'analytics_quality_desc' },
];

export default analyticsNav;
